import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import {
  ModalInput,
  Popover,
  PopoverAnchor,
  PopoverContent,
  Search,
} from "../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faKeyboard,
  faSearch,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { IconsRenderer } from "../../assets/icon-pack";

function KeyboardShortcutButtons({
  keyboardShortcuts = {},
  activeKeyboardShortcutMenu,
  setActiveKeyboardShortcutMenu,
}) {
  useLayoutEffect(() => {
    // Make buttons of equal width
    var buttons = document.querySelectorAll(".keyboard-shortcuts-btn");
    var maxWidth = 0;
    buttons.forEach((button) => {
      if (button.offsetWidth > maxWidth) {
        maxWidth = button.offsetWidth;
      }
    });
    buttons.forEach((button) => {
      button.style.minWidth = `${maxWidth}px`;
    });
  }, []);

  return (
    <>
      {Object.keys(keyboardShortcuts).map((menu) => {
        return (
          <button
            key={`keyboard-shortcut-menu-${menu}`}
            onClick={(e) => setActiveKeyboardShortcutMenu(menu)}
            className={`keyboard-shortcuts-btn btn-shadow text-xs duration-300 bg-ui-light-white rounded-[21px] ${
              activeKeyboardShortcutMenu === menu
                ? " !bg-[#623CE7] text-white"
                : " text-black"
            }  px-2 py-1 `}
          >
            {keyboardShortcuts[menu]?.label}
          </button>
        );
      })}
    </>
  );
}

function KeyboardModal({ open, setOpen, keyboardShortcuts = {} }) {
  const [activeKeyboardShortcutMenu, setActiveKeyboardShortcutMenu] =
    useState("common-actions");
  const [searchText, setSearchText] = useState("");
  const [searchResultPopover, setSearchResultPopover] = useState(true);
  const [searchResult, setSearchResult] = useState([]);
  const inputRef = useRef(null);

  return (
    <ModalInput
      isOpened={open}
      onOutsideClick={() => {
        setOpen(false);
        setSearchResult([]);
        setSearchText("");
      }}
      backgroundColor={"rgba(45, 38, 71, 0.31)"}
    >
      <div
        id="postEditorKeyboardShortcuts"
        className="post-edit-keyboard-shortcuts overflow-hidden bg-white rounded-[21px] w-[60vw] h-[90vh] p-6 pt-7"
      >
        <div className="flex items-center justify-between pr-4">
          <div className="flex text-xl items-center gap-3 ">
            <IconsRenderer name="Keyboard" />
            <h3 className="modal-heading">Keyboard Shortcuts</h3>
          </div>
          <div className="w-[50%]">
            <Popover
              placement="bottom"
              open={searchResultPopover}
              onOpenChange={(e) => {
                if (!e) {
                  setSearchResult([]);
                }
              }}
            >
              <PopoverAnchor>
                <Search
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    var allKeyboardShortcuts = Object.keys(keyboardShortcuts)
                      .map((item) => keyboardShortcuts[item]?.shortcuts ?? [])
                      .flat();
                    var tempSearchResult = [];

                    if (e.target.value !== "") {
                      allKeyboardShortcuts.filter((shortcut) => {
                        if (
                          shortcut.label.match(e.target.value) ||
                          shortcut.id.match(e.target.value)
                        ) {
                          tempSearchResult.push(shortcut);
                        }
                      });
                      setSearchResult((oldArr) => [...tempSearchResult]);
                    } else {
                      setSearchResult([]);
                    }
                  }}
                />
              </PopoverAnchor>
              <PopoverContent className="!w-[27%] !mt-2 !overflow-y-auto !max-h-[60vh] !rounded-[21px] !z-[1000000] grigora-custom-scrollbar !outline-none">
                <ul
                  autoFocus={false}
                  className="bg-white rounded-[21px] text-xs"
                >
                  {searchResult.length > 0 &&
                    searchResult.map((shortcut, i) => {
                      return (
                        <li
                          className="flex justify-between px-4 hover:bg-[#d9d9d936] rounded-[21px] p-3"
                          key={`${shortcut.label}`}
                        >
                          <span>{shortcut.label}</span>
                          <span className="text-[#8593ED] font-medium">
                            {navigator.platform === "Win32"
                              ? shortcut.windows
                              : shortcut.mac}
                          </span>
                        </li>
                      );
                    })}
                </ul>
              </PopoverContent>
            </Popover>
          </div>
          <button
            onClick={() => {
              setOpen(false);
              setSearchText("");
              setSearchResult([]);
            }}
          >
            <FontAwesomeIcon icon={faTimes} className="cursor-pointer" />
          </button>
        </div>
        <div className="flex justify-start gap-5 border-b-[1px] border-[#C7CEFF] pb-3 pt-5">
          <KeyboardShortcutButtons
            keyboardShortcuts={keyboardShortcuts}
            activeKeyboardShortcutMenu={activeKeyboardShortcutMenu}
            setActiveKeyboardShortcutMenu={setActiveKeyboardShortcutMenu}
          />
        </div>
        <div className="mt-3 grigora-custom-scrollbar overflow-y-auto h-[70vh] ">
          <div className="grid grid-cols-2 gap-4 py-4">
            {keyboardShortcuts[activeKeyboardShortcutMenu]?.shortcuts?.map(
              (shortcut, i) => {
                return (
                  <div
                    key={`${shortcut.id}-${i}`}
                    className="flex justify-between p-1"
                  >
                    <div className="text-xs">{shortcut.label}</div>
                    <div className="text-xs text-[#8593ED]">
                      {navigator.platform === "Win32"
                        ? shortcut.windows
                        : shortcut.mac}
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      </div>
    </ModalInput>
  );
}

export default KeyboardModal;
